import { BehaviorSubject, Subject } from "rxjs";
import { isAuth, getToken } from "../../../auth/shared/utils/auth";
import { get, put, post, del } from "../../../http";

export type News = {
  id: number;
  createdDate: string;
  caption: string;
  description: string;
};

export enum NewsError {
  Network,
  Server,
  InvalidCredentials,
  NotVerified,
}

export class NewsService {
  private _baseUrl: string;
  private _news$ = new BehaviorSubject<News[]>([]);
  private _error$ = new Subject<NewsError>();
  private _loading$ = new BehaviorSubject<boolean>(false);

  public get error$() {
    return this._error$.asObservable();
  }

  public get news$() {
    return this._news$.asObservable();
  }

  public get news() {
    return this._news$.value;
  }

  public get loading$() {
    return this._loading$.asObservable();
  }

  public get loading() {
    return this._loading$.value;
  }

  constructor(apiUrl?: string) {
    this._baseUrl = (apiUrl || "http://basf-new.app.test/backend/api") + "/News";
  }

  // TODO Вынести в глобальный метод добавление заголовка
  addAuthInHeadersOption = () => {
    let options = {};
    if (isAuth()) {
      const token = getToken();
      options = {
        headers: {
          Authorization: `Bearer ${token}`,
          'Pragma': "no-cache" 
        },
      };
    }
    return options;
  };

  async getNews() {
    try {
      this._loading$.next(true);

      const options = this.addAuthInHeadersOption();
      const result = await get(`${this._baseUrl}`, undefined, options);
      result.json().then((res) => {
        this._news$.next(res);
      });

      this._loading$.next(false);
    } catch (err) {
      this._loading$.next(false);

      // TODO: Добавить логику обработки ошибок
      // eslint-disable-next-line no-console
      console.error("get news fail");
      // eslint-disable-next-line no-console
      console.error(err);
      throw err;
    }
  }

  async addNews(caption: string, description: string, date: string) {
    try {
      this._loading$.next(true);
      const options = this.addAuthInHeadersOption();
      await post(
        `${this._baseUrl}`,
        {
          caption: caption,
          description: description,
          createdDate: date,
        },
        options,
      );

      this._loading$.next(false);
    } catch (err) {
      this._loading$.next(false);

      // TODO: Добавить логику обработки ошибок
      // eslint-disable-next-line no-console
      console.error("save user info fail");
      // eslint-disable-next-line no-console
      console.error(err);
      throw err;
    }
    this.getNews();
  }

  async changeNews(newsData: News) {
    try {
      this._loading$.next(true);

      const options = this.addAuthInHeadersOption();
      await put(
        `${this._baseUrl}/${newsData.id}`,
        {
          caption: newsData.caption,
          description: newsData.description,
          createdDate: newsData.createdDate, 
        },
        options,
      );

      this._loading$.next(false);
    } catch (err) {
      this._loading$.next(false);

      // TODO: Добавить логику обработки ошибок
      // eslint-disable-next-line no-console
      console.error("change user password fail");
      // eslint-disable-next-line no-console
      console.error(err);
      throw err;
    }
    this.getNews();
  }

  async deleteNews(id: number) {
    try {
      this._loading$.next(true);

      const options = this.addAuthInHeadersOption();
      await del(`${this._baseUrl}/${id}`, options);

      this._loading$.next(false);
    } catch (err) {
      this._loading$.next(false);

      // TODO: Добавить логику обработки ошибок
      // eslint-disable-next-line no-console
      console.error("change user password fail");
      // eslint-disable-next-line no-console
      console.error(err);
      throw err;
    }
    this.getNews();
  }
}
